export enum ContactDistributionType {
  business = 'BUSINESS',
  personal = 'PERSONAL'
}
